<template>
    <div :class="['preloader', { 'active': working }]">
        <div class="indeterminate" />
    </div>
</template>

<script>
    export default {
        props: {
            working: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style lang="less">
    @progress-bar-color: #2eabff;

    .preloader {
        position: relative;
        display: block;

        height: 2px;

        width: 100%;
        overflow: hidden;

        &.active {
            background-color: lighten(@progress-bar-color, 30%);

            .indeterminate {
                background-color: @progress-bar-color;

                &:before {
                    content: '';

                    position: absolute;
                    background-color: inherit;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    will-change: left, right;

                    animation: indeterminate 2.1s cubic-bezier(0.650, 0.815, 0.735, 0.395) infinite;
                }

                &:after {
                    content: '';

                    position: absolute;
                    background-color: inherit;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    will-change: left, right;

                    animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.840, 0.440, 1.000) infinite;
                    animation-delay: 1.15s;
                }
            }
        }
    }

    .box-actions, .box-header {
        .preloader {
            position: absolute;

            bottom: -1px;
            left: 0;
            right: 0;
        }
    }

    @keyframes indeterminate {
        0% {
            left: -35%;
            right:100%;
        }
        60% {
            left: 100%;
            right: -90%;
        }
        100% {
            left: 100%;
            right: -90%;
        }
    }

    @keyframes indeterminate-short {
        0% {
            left: -200%;
            right: 100%;
        }
        60% {
            left: 107%;
            right: -8%;
        }
        100% {
            left: 107%;
            right: -8%;
        }
    }
</style>
